import reducer from './reducers';

export { default as editResourceSelectors } from './selectors';
export { default as editResourceOperations } from './operations';
export { default as editResourceTypes } from './types';

export default reducer;
